import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    chargeRateList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    chargeRateDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const chargeRateSlice = createSlice({
  name: 'chargeRate',
  initialState,
  reducers: {
    getChargeRateList: (state, action) => {
        state.chargeRateList.requesting = true;
        state.chargeRateList.error = null;
        state.chargeRateList.items = [];
        state.chargeRateList.success = false;
        state.salaryAdditionList.filters = action.payload;
    },
    getChargeRateListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.chargeRateList.requesting = false;        
        state.chargeRateList.items = data;
        state.chargeRateList.success = true; 
        state.chargeRateList.pagination.current_page = current_page;
        state.chargeRateList.pagination.per_page = per_page;
        state.chargeRateList.pagination.total = total;
    },
    getChargeRateListFail: (state, action) => {        
        state.chargeRateList.requesting = false;
        state.chargeRateList.error = action.payload;
    },
    getChargeRateDetails: (state) => {
        state.chargeRateDetails.requesting = true;
        state.chargeRateDetails.error = null;
        state.chargeRateDetails.data = null;
        state.chargeRateDetails.success = false; 
    },
    getChargeRateDetailsSuccess: (state, action) => {
        state.chargeRateDetails.requesting = false;
        state.chargeRateDetails.data = action.payload;
        state.chargeRateDetails.success = true; 
    },
    getChargeRateDetailsFail: (state, action) => {        
        state.chargeRateDetails.requesting = false;
        state.chargeRateDetails.error = action.payload;
    },
    doChargeRateCreate: (state) => {
        state.chargeRateDetails.requesting = true;
        state.chargeRateDetails.error = null;
        state.chargeRateDetails.data = null;
        state.chargeRateDetails.success = false; 
    },
    doChargeRateUpdate: (state) => {
        state.chargeRateDetails.requesting = true;
        state.chargeRateDetails.error = null;
        state.chargeRateDetails.data = null;
        state.chargeRateDetails.success = false; 
    },
    doChargeRateDelete: (state) => {
        state.chargeRateDetails.requesting = true;
        state.chargeRateDetails.error = null;
        state.chargeRateDetails.data = null;
        state.chargeRateDetails.success = false; 
    },
  },
})

export const { 
    getChargeRateList, getChargeRateListSuccess, getChargeRateListFail,
    getChargeRateDetails, getChargeRateDetailsSuccess, getChargeRateDetailsFail,
    doChargeRateCreate, doChargeRateUpdate, doChargeRateDelete
} = chargeRateSlice.actions

export default chargeRateSlice.reducer